var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74893 9.7025L11.7489 1.7025C12.1389 1.3125 12.1389 0.6825 11.7489 0.2925C11.3589 -0.0975 10.7289 -0.0975 10.3389 0.2925C10.3089 0.3225 10.2789 0.3625 10.2489 0.3925L4.05893 7.4525L1.79893 4.4425C1.46893 4.0025 0.838932 3.9125 0.398932 4.2425C-0.0410682 4.5725 -0.131068 5.2025 0.198932 5.6425L3.19893 9.6425C3.52893 10.0825 4.15893 10.1725 4.59893 9.8425C4.65893 9.8025 4.70893 9.7525 4.74893 9.7025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.9b78351faff6d12e7e0a22fa137c6f78.svg";
export { ForwardRef as ReactComponent };